// Isolated Shadow DOM host so the widget's CSS never collides with the host app.
// The shadow root is CLOSED: host.shadowRoot === null, so session recorders on the host page
// (including our own bundled rrweb) can neither serialize nor observe the widget's internals —
// this is what keeps the widget out of its own recordings at the mutation-observer level, not
// just the serializer level. Our code keeps the only reference.
// The install snippet is <script async> in <head>, so document.body may not exist yet —
// mounting is deferred until it does.

export function createShadow(onReady) {
  const host = document.createElement('div');
  host.setAttribute('data-ff-root', '');
  // Reset inheritance; the host is a zero-size anchor — children are position:fixed to the viewport.
  host.style.cssText = 'all: initial;';
  const shadow = host.attachShadow({ mode: 'closed' });

  const mount = () => document.body.appendChild(host);
  if (document.body) {
    mount();
    if (onReady) onReady();
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      mount();
      if (onReady) onReady();
    }, { once: true });
  }

  return shadow;
}
